import React, { useEffect } from "react";
/* eslint-disable */
import Carousels from "./Carousel";
import Cards from "./Cards";
import Services from './Services';
import Header from './header'
import ExploreSolutions from './ExploreSolutions';
import ExploreProducts from "./ExploreProducts";
import DataCentreGlobally from './DataCentreGlobally';
import Footer from './Footer';

function LandingPage() {
    useEffect(()=>{
        window.scrollTo(0,0)
    },[])
    return (
        <div className="App">
            <Header/>
            <Carousels />
            <Cards />
            <Services />
            <ExploreProducts />
            <ExploreSolutions />
            <DataCentreGlobally />
            <Footer />
        </div>
    );
    }
export default LandingPage
